import { render, staticRenderFns } from "./CreateAgreementChange.vue?vue&type=template&id=55e0abb7"
import script from "./CreateAgreementChange.vue?vue&type=script&lang=js"
export * from "./CreateAgreementChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports